import DateRangeSelectorContainer from './containers/DateRangeSelectorContainer'

export default DateRangeSelectorContainer
